// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UpdateStatus.UpdateStatus {\n  max-width: none;\n  flex-shrink: 0;\n}", "",{"version":3,"sources":["webpack://./src/components/common/UpdateStatus.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF","sourcesContent":[".UpdateStatus.UpdateStatus {\n  max-width: none;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
